import React from 'react';

import EditIcon from '@mui/icons-material/Edit';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import {
    Box,
    Card,
    Grid,
    IconButton,
    Typography,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import PreviewLocation from 'common/components/PreviewLocation';

const ProjectCard = ({ handleClickUpdate, isFetching, project }) => {
    const { t } = useTranslation();

    if (isFetching) return null;

    return (
        <Card>
            <Card.Header>
                <Grid container>
                    <Grid
                        size="grow"
                        sx={{ display: 'flex', alignItems: 'center' }}
                    >
                        <Typography variant="body1" fontWeight="bold">
                            {t('Project Data')}
                        </Typography>
                        <Box sx={{ ml: 'auto' }}>
                            <IconButton
                                onClick={() => handleClickUpdate(project)}
                            >
                                <EditIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    </Grid>
                </Grid>
            </Card.Header>

            <Card.Body>
                <PreviewLocation
                    position={{
                        position: {
                            latitude: project.latitude,
                            longitude: project.longitude,
                        },
                        markerIcon: <LocationOnIcon fontSize="small" />,
                        title: project.address,
                    }}
                />
            </Card.Body>
        </Card>
    );
};

ProjectCard.propTypes = {
    handleClickUpdate: PropTypes.func,
    isFetching: PropTypes.bool,
    project: PropTypes.object,
};

export default ProjectCard;
